import { render } from "./memo.vue?vue&type=template&id=b02b3b62"
import script from "./memo.vue?vue&type=script&lang=js"
export * from "./memo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__